import { useTranslation } from 'react-i18next';
import type { FlatfinderPerspective } from 'realitiq-utils/src/flatfinder';
import { Modal } from '@/components/modals/new/modal';
import { PerspectiveForm } from './perspective-form';

export function FlatfinderPerspectiveModal({
  form,
  projectId,
  uploading,
  onBusyChange,
  onDismiss,
  onSave,
}: {
  form: 'new' | FlatfinderPerspective | null;
  projectId: string;
  uploading: boolean;
  onBusyChange: (busy: boolean) => void;
  onDismiss: () => void;
  onSave: (perspective: FlatfinderPerspective) => void;
}) {
  const { t } = useTranslation();
  if (!form) return null;

  return (
    <Modal
      isOpen
      open={() => {}}
      dismiss={onDismiss}
      dismissDisabled={uploading}
      dismissOnOutsideClick={false}
      title={
        form === 'new'
          ? t('flatfinderWorkspaceCreatePerspective')
          : t('flatfinderWorkspaceEditPerspective')
      }
      className="max-h-[90dvh] max-w-2xl overflow-y-auto rounded-lg border border-primary-light/20 shadow-lg"
    >
      <Modal.Body>
        <PerspectiveForm
          key={form === 'new' ? 'new' : form.id}
          projectId={projectId}
          initial={form === 'new' ? undefined : form}
          onCancel={onDismiss}
          onBusyChange={onBusyChange}
          onSave={onSave}
        />
      </Modal.Body>
    </Modal>
  );
}
